import { ITextProps, Text } from 'native-base'

const P = ({ children }: ITextProps) => <Text py={1}>{children}</Text>

export default P
